module.exports = __webpack_public_path__ + "static/bcs_coding_kids-dd24a7ae2497d8822c328515f3e87d0a.jpg";